import MyVendorRequestBadge from "./MyVendorRequestBadge";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function bucketize(items, buckets) {
  const output = buckets.map((bucket) => ({ ...bucket, items: [] }));
  items.forEach((item) => {
    const index = output.findIndex((bucket) => bucket.matches(item));
    if (index >= 0) output[index].items.push(item);
  });
  return output.filter((bucket) => bucket.items.length > 0);
}

const DEFAULT_VISIBLE_COUNT = 1;

/**
 * Status-grouped request list with shared expand state (prototype GroupedRequestSection).
 * Collapsed: first badge only + "Show N more". Expanded: all badges + "Show less".
 */
export default function MyVendorGroupedRequests({
  items = [],
  emptyLabel = "No requests",
  expanded = false,
  onToggleExpanded,
  statusBuckets = [],
  inverted = false,
  onRequestClick,
}) {
  if (!items.length) {
    return <span className="text-xs text-gray-400">{emptyLabel}</span>;
  }

  const visible = expanded ? items : items.slice(0, DEFAULT_VISIBLE_COUNT);
  const buckets = bucketize(visible, statusBuckets);
  const hiddenCount = items.length - DEFAULT_VISIBLE_COUNT;

  return (
    <div className="flex flex-col gap-3 pt-2">
      {buckets.map((bucket) => (
        <div key={bucket.key} className="flex flex-col gap-1.5">
          <div className="inline-flex items-center text-[10px] font-semibold uppercase tracking-wide text-gray-400">
            {bucket.dotClass ? (
              <span
                className={classNames("mr-1.5 inline-block h-2 w-2 rounded-full", bucket.dotClass)}
                aria-hidden="true"
              />
            ) : null}
            {bucket.label}
          </div>
          <div className="flex flex-col gap-2">
            {bucket.items.map((request) => (
              <MyVendorRequestBadge
                key={request.id}
                request={request}
                inverted={inverted}
                onClick={onRequestClick}
              />
            ))}
          </div>
        </div>
      ))}

      {!expanded && hiddenCount > 0 ? (
        <button
          type="button"
          onClick={(event) => {
            event.stopPropagation();
            onToggleExpanded?.(true);
          }}
          className="self-start text-xs font-medium text-indigo-600 hover:text-indigo-700"
        >
          Show {hiddenCount} more
        </button>
      ) : null}

      {expanded && hiddenCount > 0 ? (
        <button
          type="button"
          onClick={(event) => {
            event.stopPropagation();
            onToggleExpanded?.(false);
          }}
          className="self-start text-xs font-medium text-gray-500 hover:text-gray-700"
        >
          Show less
        </button>
      ) : null}
    </div>
  );
}
